<!-- eslint @angular-eslint/template/eqeqeq: 0 -->
<div
  class="display-table"
  [ngClass]="{
    'q9-activity-shape-sfa': isArchitecture(),
    'q9-activity-shape': !isArchitecture()
  }"
  [ngStyle]="{opacity: (isEditing | async) ? '0.45' : '1'}">
  <div class="fill">
    <div class="tools" [ngStyle]="{right: borderWidth, left: borderWidth}">
      <div class="row">
        <a
          class="drilldown"
          (click)="drillDown()"
          [ngStyle]="colors"
          *q9Screenshot="configForDrilldownScreenshot"
          [ngClass]="{'drilldown-on': source.drilldowns || source.linkedDiagram}">
          <mat-icon
            *ngIf="source.drilldowns || source.linkedDiagram"
            [svgIcon]="icon"
            class="drilldown-icon"
            [ngStyle]="{fill: colors.fill}"></mat-icon>
          <div class="number" [ngClass]="{hidden: hiddenNumber}">
            {{ number }}
          </div>
        </a>
        <div class="attachments-box">
          <app-org-model-link
            [source]="source"
            *ngIf="
              (toolbarState$ | async).expanded &&
              !(toolbarState$ | async).isStripped &&
              source.orgModelAttachments?.length
            "></app-org-model-link>
          <app-activity-paperclip
            [infoStyle]="infoStyle"
            [source]="source"
            *ngIf="showPaperclip; else paperclipPlaceHolder"></app-activity-paperclip>
          <ng-template #paperclipPlaceHolder>
            <div class="paperclip-placeholder"></div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="image-mode" *ngIf="imageMode | async" (click)="toDrilldownInView()">
      <div class="empty-box" *ngIf="!source.image">
        <h2>{{ 'ASIDE_R.NO_IMAGE_ADDED' | translate }}</h2>
      </div>
      <div
        class="image-box"
        *ngIf="source.image"
        [style.backgroundImage]="safeImageUrl(source.imageUrl)">
        <div class="text-box">
          <div class="text" [ngStyle]="fontWrapper">
            <div
              class="text-content"
              [ngStyle]="fontStyle"
              [innerHTML]="textSub | async | sanitizer: 'html'"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="default-mode" *ngIf="!(imageMode | async) && !isArchitecture()">
      <div class="text" [ngStyle]="fontWrapper">
        <div
          class="text-content"
          *ngIf="!(isEditing | async)"
          [ngStyle]="fontStyle"
          [innerHTML]="textSub | async | sanitizer: 'html'"></div>
      </div>
    </div>

    <div class="sfa-mode" *ngIf="isArchitecture()">
      <div
        class="text"
        [ngClass]="{'text-with-icon': mainResource && !mainResource.hidden}"
        [ngStyle]="fontWrapper">
        <div
          class="text-main-icon"
          *ngIf="mainResource && !mainResource.hidden"
          [matTooltip]="mainResource.name | decodeHtml"
          [matTooltipShowDelay]="400"
          [matTooltipHideDelay]="400"
          [matTooltipPosition]="'right'"
          [matTooltipClass]="{'break-word': true}"
          [style.backgroundImage]="safeImageUrl(mainResource?.icon)">
          {{ mainResource?.icon ? '' : mainResource.name[0] }}
        </div>
        <div
          *ngIf="!(isEditing | async)"
          class="text-content"
          [ngClass]="{center: isAgentInteraction()}"
          [ngStyle]="fontStyle"
          [innerHTML]="textSub | async | sanitizer: 'html'"></div>
      </div>
      <div
        class="activity-attributes"
        [ngClass]="{
          'attributes-with-padding': mainResource && !mainResource.hidden && !attributePadding
        }"
        *ngIf="!(isEditing | async)">
        <div
          class="attribute-item"
          [attr.special-target]="'attributeItem'"
          [attr.mx-key]="attribute.mxKey"
          [matTooltip]="attribute.description | decodeHtml"
          matTooltipShowDelay="400"
          matTooltipHideDelay="400"
          [matTooltipPosition]="'below'"
          [matTooltipClass]="{'tooltip-breaker': true}"
          *ngFor="let attribute of attributes; index as $i"
          [innerHTML]="attribute.text | sanitizer: 'html'"></div>
      </div>
      <div class="footer-margin-holder" *ngIf="source?.footerText"></div>
      <div
        class="footer-text"
        [attr.special-target]="'footerText'"
        *ngIf="source?.footerText && !(isEditing | async)"
        [innerHTML]="source?.footerText | sanitizer: 'html'"></div>
      <div class="empty-placeholder" *ngIf="source?.footerText"></div>
    </div>
  </div>

  <div
    class="resources-sfa"
    *ngIf="isArchitecture(); else resourcesTemplate"
    [ngClass]="{'capture-mode': captureMode}"
    [ngStyle]="transparencyLevel()">
    <div class="resource-margin-holder" *ngIf="resources.length"></div>
    <div
      class="list-group pulse"
      *ngIf="!resourceLines.size; else resourceLinesTemplate"
      #resContainerRef
      [ngStyle]="{'margin-bottom': isAgentInteraction() ? '0px' : '10px'}"
      [dragula]="dragulaBagPrefix"
      [dragulaModel]="resources"
      [attr.allow-drop]="allowDrop ? 1 : 0"
      [attr.act-id]="source.mxKey"
      [ngClass]="{'pulse-green': allowDrop === true, 'pulse-red': allowDrop === false}"></div>
    <ng-template #resourceLinesTemplate>
      <div
        #resContainerRef
        class="list-group pulse"
        *ngFor="
          let resourceLine of resourceLines | keyvalue;
          index as $li;
          trackBy: trackByResourceLine
        "
        [dragula]="dragulaBagPrefix"
        [dragulaModel]="resources"
        [attr.allow-drop]="allowDrop && $li == 0 ? 1 : 0"
        [attr.act-id]="source.mxKey"
        [ngClass]="{
          'pulse-green': allowDrop === true && $li == 0,
          'pulse-red': allowDrop === false && $li == 0
        }">
        <div
          class="list-group-item resource resource-sfa"
          [matTooltip]="resource.name | decodeHtml"
          [matTooltipShowDelay]="400"
          [matTooltipHideDelay]="400"
          [matTooltipPosition]="'right'"
          [matTooltipClass]="{'break-word': true}"
          *ngFor="let resource of resourceLine.value; index as $i; trackBy: trackByResource"
          (mousedown)="overloadWithMetadata($event, resource, $i)">
          <ng-container *ngIf="resource">
            <!-- ngIf for a very rare case of dragula causing model desync, leaving resource undefined -->
            <div
              class="resource-content"
              [ngClass]="{'drag-item-handle': (mode | async).edit}"
              [style.backgroundImage]="safeImageUrl(resource.icon)">
              {{ resource.icon ? '' : resource.name[0] }}
            </div>
          </ng-container>
        </div>
      </div>
    </ng-template>

    <div class="card-margin-holder" *ngIf="resourceLines.size || source?.footerText"></div>
  </div>

  <ng-template #resourcesTemplate>
    <div
      class="resources"
      [ngClass]="{'capture-mode': captureMode}"
      [ngStyle]="transparencyLevel()">
      <div
        #resContainerRef
        class="list-group pulse"
        [dragula]="dragulaBagPrefix"
        [dragulaModel]="resources"
        [attr.allow-drop]="allowDrop ? 1 : 0"
        [attr.act-id]="source.mxKey"
        [ngClass]="{'pulse-green': allowDrop === true, 'pulse-red': allowDrop === false}">
        <div
          class="list-group-item resource"
          [matTooltip]="resource.name | decodeHtml"
          [matTooltipShowDelay]="400"
          [matTooltipHideDelay]="400"
          [matTooltipPosition]="'right'"
          [matTooltipClass]="{'break-word': true}"
          *ngFor="let resource of resources | hiddenResource; index as $i; trackBy: track"
          (mousedown)="overloadWithMetadata($event, resource, $i)">
          <ng-container *ngIf="resource">
            <!-- ngIf for a very rare case of dragula causing model desync, leaving resource undefined -->
            <div class="resource-content" [ngClass]="{'drag-item-handle': (mode | async).edit}">
              <ng-container *ngIf="resource.rasci">
                <div class="rasci-container">
                  <div class="rasci-icon r" *ngIf="resource.rasci.responsible">R</div>
                  <div class="rasci-icon a" *ngIf="resource.rasci.accountable">A</div>
                  <div class="rasci-icon s" *ngIf="resource.rasci.supporting">S</div>
                  <div class="rasci-icon c" *ngIf="resource.rasci.consulted">C</div>
                  <div class="rasci-icon i" *ngIf="resource.rasci.informed">I</div>
                </div>
              </ng-container>
              <span
                class="name"
                [ngStyle]="resStyle[resource.type | resourceType]"
                [innerHTML]="resource.name | htmlEncoder"></span>
            </div>
            <mat-icon
              (click)="detachResource(resource, $i)"
              class="list-group-item-delete"
              *ngIf="(mode | async).edit"
              svgIcon="close"></mat-icon>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<div class="shadow-holder" #shadowHolder *ngIf="isArchitecture()"></div>
